// @ts-nocheck
import { BaseEdge, type EdgeProps, getBezierPath } from '@xyflow/react';

export function AnimatedFlowEdge(props: EdgeProps) {
    const [edgePath] = getBezierPath(props);

    return (
        <g>
            {/* Base solid blue line */}
            <path
                d={edgePath}
                stroke="#1976D2"
                strokeWidth={3}
                fill="none"
            />
            {/* Animated white dashed overlay */}
            <path
                d={edgePath}
                stroke="white"
                strokeWidth={2}
                fill="none"
                strokeDasharray="8 12"
                strokeDashoffset={0}
                style={{
                    animation: 'dash-flow 1.5s linear infinite',
                }}
            />
        </g>
    );
}
